<template>
  <div class="m-0 dbozone-font bg-romaplus" :class="`${lang}-font`">
    <div class="container d-flex flex-column justify-content-center">
      <div class="d-flex flex-column nav-romaplus">
        <section class="d-flex p-2">
          <h5 class="font-weight-bold m-0 text-title" :class="`-${lang}`">
            {{ $t("romaplus.name") }}
          </h5>
        </section>
      </div>
      <div class="d-flex p-2 mt-1" v-for="(text, index) in textList" :key="index" >
        <div v-if="index===2">
          <div v-if="lang==='zh'" class="">
            <span class="m-0 text-sub" :class="`-${lang}`">
              {{ $t(`${text}_1`) + baseBet + $t(`${text}_2`) + betLevel[0] + $t('info.to') + betLevel[betLevel.length-1] + $t(`${text}_3`) + betSize[0] + $t('info.to') + betSize[betSize.length-1] }}
            </span>
          </div>
          <div v-else class="">
            <span class="m-0 text-sub" :class="`-${lang}`">
              {{ $t(`${text}_1`) + baseBet + $t(`${text}_2`) + betLevel[0] + $t('info.to') + betLevel[betLevel.length-1] + $t(`${text}_3`) + betSize[0] + $t('info.to') + betSize[betSize.length-1] }}
            </span>
          </div>
        </div>
        <div v-else>
          <span class="m-0 text-sub" :class="`-${lang}`">{{ $t(text) }}</span>
        </div>
      </div>

      <div class="d-flex flex-column nav-romaplus">
        <section class="d-flex p-2">
          <h5 class="font-weight-bold m-0 text-title" :class="`-${lang}`">{{ $t('bonusGameBuy.title') }}</h5>
        </section>
      </div>
      <div class="d-flex p-2 mt-1">
        <span class=" m-0 text-sub" :class="`-${lang}`">{{ $t('bonusGameBuy.text1') }}</span>
      </div>
      <div class="d-flex p-2 mt-1">
        <span class=" m-0 text-sub" :class="`-${lang}`">{{ $t('bonusGameBuy.text2') }}</span>
      </div>

      <div class="d-flex flex-column nav-romaplus">
        <section class="d-flex p-2">
          <h5 class="font-weight-bold m-0 text-title" :class="`-${lang}`">
            {{ $t('main-game.title') }}
          </h5>
        </section>
      </div>
      <div class="d-flex p-2 mt-1 justify-content-center">
        <img
          class="mt-3 iconSmall-info-romaplus"
          :src="require(`../../assets/ruleGames/wallet_icon.png`)"
          alt=""
        />
      </div>
      <div class="d-flex p-2 justify-content-center">
        <span class="m-0 text-sub" :class="`-${lang}`">{{
          $t("main-game.wallet-balance")
        }}</span>
      </div>
      <div class="d-flex p-2">
        <span class="m-0 text-sub" :class="`-${lang}`">{{
          $t("main-game.text-wallet")
        }}</span>
      </div>
      <div class="d-flex p-2 mt-1 justify-content-center">
        <img
          class="mt-3 iconSmall-info-romaplus"
          :src="require(`../../assets/ruleGames/romaplus/bet_amount_icon.svg`)"
          alt=""
        />
      </div>
      <div class="d-flex p-2 mt-1 justify-content-center">
        <span class="m-0 text-sub" :class="`-${lang}`">{{ $t("main-game.bet-amount") }}</span>
      </div>
      <div class="d-flex p-2">
        <span class="m-0 text-sub" :class="`-${lang}`">{{ $t("main-game.text-bet1") }}</span>
      </div>
      <div class="d-flex p-2">
        <span class="m-0 text-sub" :class="`-${lang}`">{{ $t("main-game.text-bet2") }}</span>
      </div>
      <div class="d-flex p-2">
        <span class="m-0 text-sub" :class="`-${lang}`">{{ $t("main-game.text-bet3") }}</span>
      </div>
      <div class="d-flex p-2 mt-1 justify-content-center">
        <img
          class="mt-3 iconSmall-info-romaplus"
          :src="require(`../../assets/ruleGames/romaplus/win_icon.svg`)"
          alt=""
        />
      </div>
      <div class="d-flex p-2 justify-content-center">
        <span class="m-0 text-sub" :class="`-${lang}`">{{ $t("main-game.win-amount") }}</span>
      </div>
      <div class="d-flex p-2">
        <span class="m-0 text-sub" :class="`-${lang}`">{{
          $t("main-game.text-win-amount")
        }}</span>
      </div>
      <div class="d-flex p-2 mt-1 justify-content-center">
        <img
          class="mt-3 icon-info-romaplus"
          :src="require(`../../assets/ruleGames/romaplus/spin_btn.png`)"
          alt=""
        />
      </div>
      <div class="d-flex p-2 justify-content-center">
        <span class="m-0 text-sub" :class="`-${lang}`">{{ $t("main-game.spin") }}</span>
      </div>
      <div class="d-flex p-2">
        <span class="m-0 text-sub" :class="`-${lang}`">{{ $t("main-game.text-spin1") }}</span>
      </div>
      <div class="d-flex p-2">
        <span class="m-0 text-sub" :class="`-${lang}`">{{ $t("main-game.text-spin2") }}</span>
      </div>
      <div class="d-flex p-2">
        <span class="m-0 text-sub" :class="`-${lang}`">{{ $t("main-game.text-spin3") }}</span>
      </div>
      <div class="d-flex p-2">
        <span class="m-0 text-sub" :class="`-${lang}`">{{ $t("main-game.text-spin4") }}</span>
      </div>
      <div class="d-flex p-2 mt-1 justify-content-center">
        <img
          class="mt-3 icon-info-romaplus"
          :src="require(`../../assets/ruleGames/romaplus/stop_btn.png`)"
          alt=""
        />
      </div>
      <div class="d-flex p-2 justify-content-center">
        <span class="m-0 text-sub" :class="`-${lang}`">{{ $t("main-game.stop") }}</span>
      </div>
      <div class="d-flex p-2">
        <span class="m-0 text-sub" :class="`-${lang}`">{{ $t("main-game.text-stop") }}</span>
      </div>
      <div class="d-flex p-2 justify-content-center">
        <img
          class="mt-3 icon-info-romaplus"
          :src="require(`../../assets/ruleGames/romaplus/minus_btn.png`)"
          alt=""
        />
      </div>
      <div class="d-flex p-2 justify-content-center">
        <span class="m-0 text-sub" :class="`-${lang}`">{{ $t("main-game.minus") }}</span>
      </div>
      <div class="d-flex p-2">
        <span class="m-0 text-sub" :class="`-${lang}`">{{ $t("main-game.text-minus") }}</span>
      </div>
      <div class="d-flex p-2 mt-1 justify-content-center">
        <img
          class="mt-3 icon-info-romaplus"
          :src="require(`../../assets/ruleGames/romaplus/plus_btn.png`)"
          alt=""
        />
      </div>
      <div class="d-flex p-2 justify-content-center">
        <span class="m-0 text-sub" :class="`-${lang}`">{{ $t("main-game.plus") }}</span>
      </div>
      <div class="d-flex p-2">
        <span class="m-0 text-sub" :class="`-${lang}`">{{ $t("main-game.text-plus") }}</span>
      </div>
      <div class="d-flex p-2 mt-1 justify-content-center">
        <img
          class="mt-3 icon-info-romaplus"
          :src="require(`../../assets/ruleGames/romaplus/auto_spin_btn.png`)"
          alt=""
        />
      </div>
      <div class="d-flex p-2 justify-content-center">
        <span class="m-0 text-sub" :class="`-${lang}`">{{ $t("main-game.autospin") }}</span>
      </div>
      <div class="d-flex p-2">
        <span class="m-0 text-sub" :class="`-${lang}`">{{ $t("main-game.text-auto1") }}</span>
      </div>
      <div class="d-flex p-2">
        <span class="m-0 text-sub" :class="`-${lang}`">{{ $t("main-game.text-auto2") }}</span>
      </div>
      <div class="d-flex p-2 mt-1 justify-content-center">
        <img
          class="mt-3 iconSmall-info-romaplus"
          :src="require(`../../assets/ruleGames/romaplus/menu_btn.png`)"
          alt=""
        />
      </div>
      <div class="d-flex p-2 justify-content-center">
        <span class="m-0 text-sub" :class="`-${lang}`">{{ $t("main-game.menu") }}</span>
      </div>
      <div class="d-flex p-2">
        <span class="m-0 text-sub" :class="`-${lang}`">{{ $t("main-game.text-menu") }}</span>
      </div>
      <div class="d-flex p-2 mt-1 justify-content-center">
        <img
          class="mt-3 iconSmall-info-romaplus"
          :src="require(`../../assets/ruleGames/romaplus/turbo_on_icon.png`)"
          alt=""
        />
      </div>
      <div class="d-flex p-2 justify-content-center">
        <span class="m-0 text-sub" :class="`-${lang}`">{{ $t("main-game.turbo") }}</span>
      </div>
      <div class="d-flex p-2">
        <span class="m-0 text-sub" :class="`-${lang}`">{{ $t("main-game.text-turbo") }}</span>
      </div>
      <div class="d-flex p-2 mt-1 justify-content-center">
        <img
          class="mt-3 iconSmall-info-romaplus"
          :src="require(`../../assets/ruleGames/romaplus/turbo_off_icon.png`)"
          alt=""
        />
      </div>
      <div class="d-flex p-2 justify-content-center">
        <span class="m-0 text-sub" :class="`-${lang}`">{{
          $t("main-game.normal-turbo")
        }}</span>
      </div>
      <div class="d-flex p-2">
        <span class="m-0 text-sub" :class="`-${lang}`">{{
          $t("main-game.text-normal-turbo")
        }}</span>
      </div>
      <div class="d-flex p-2 mt-1 justify-content-center">
        <img
          class="mt-3 icon-info-romaplus"
          :src="require(`../../assets/ruleGames/romaplus/quit_icon.svg`)"
          alt=""
        />
      </div>
      <div class="d-flex p-2 justify-content-center">
        <span class="m-0 text-sub" :class="`-${lang}`">{{ $t("main-game.quit") }}</span>
      </div>
      <div class="d-flex p-2">
        <span class="m-0 text-sub" :class="`-${lang}`">{{ $t("main-game.text-quit") }}</span>
      </div>
      <div class="d-flex p-2 justify-content-center">
        <img
          class="mt-3 icon-info-romaplus"
          :src="require(`../../assets/ruleGames/romaplus/info_icon.svg`)"
          alt=""
        />
      </div>
      <div class="d-flex p-2 justify-content-center">
        <span class="m-0 text-sub" :class="`-${lang}`">{{ $t("main-game.pay-info") }}</span>
      </div>
      <div class="d-flex p-2">
        <span class="m-0 text-sub" :class="`-${lang}`">{{ $t("main-game.text-info") }}</span>
      </div>
      <div class="d-flex p-2 justify-content-center">
        <img
          class="mt-3 icon-info-romaplus"
          :src="require(`../../assets/ruleGames/romaplus/paytable_icon.svg`)"
          alt=""
        />
      </div>
      <div class="d-flex p-2 justify-content-center">
        <span class="m-0 text-sub" :class="`-${lang}`">{{
          $t("main-game.info-paytable")
        }}</span>
      </div>
      <div class="d-flex p-2">
        <span class="m-0 text-sub" :class="`-${lang}`">{{
          $t("main-game.text-paytable")
        }}</span>
      </div>
      <div class="d-flex p-2 justify-content-center">
        <img
          class="mt-3 icon-info-romaplus"
          :src="require(`../../assets/ruleGames/romaplus/history_icon.svg`)"
          alt=""
        />
      </div>
      <div class="d-flex p-2 justify-content-center">
        <span class="m-0 text-sub" :class="`-${lang}`">{{ $t("main-game.history") }}</span>
      </div>
      <div class="d-flex p-2">
        <span class="m-0 text-sub" :class="`-${lang}`">{{
          $t("main-game.text-history")
        }}</span>
      </div>
      <div class="d-flex p-2 justify-content-center">
        <img
          class="mt-3 icon-info-romaplus"
          :src="require(`../../assets/ruleGames/romaplus/option_icon.svg`)"
          alt=""
        />
      </div>
      <div class="d-flex p-2 justify-content-center">
        <span class="m-0 text-sub" :class="`-${lang}`">{{ $t("main-game.setting") }}</span>
      </div>
      <div class="d-flex p-2">
        <span class="m-0 text-sub" :class="`-${lang}`">{{
          $t("main-game.text-setting")
        }}</span>
      </div>
      <div class="d-flex p-2 justify-content-center">
        <img
          class="mt-3 icon-info-romaplus"
          :src="require(`../../assets/ruleGames/romaplus/close_icon.svg`)"
          alt=""
        />
      </div>
      <div class="d-flex p-2 justify-content-center">
        <span class="m-0 text-sub" :class="`-${lang}`">{{ $t("main-game.close") }}</span>
      </div>
      <div class="d-flex p-2">
        <span class="m-0 text-sub" :class="`-${lang}`">{{ $t("main-game.text-close") }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'rule-romaplus',
  props: {
    data: Object,
    lang: String,
  },
  data() {
    return {
      textList: [
        'romaplus.text-rule1',
        'romaplus.text-rule2',
        'romaplus.text-rule3',
        'romaplus.text-rule4',
        'romaplus.text-rule5',
        'romaplus.text-rule6',
        'romaplus.text-rule7',
        'romaplus.text-rule8',
        'romaplus.text-rule9',
        'romaplus.text-rule10',
        'romaplus.text-rule11',
        'romaplus.text-rule12',
        'romaplus.text-rule13'
      ],
      baseBet: this.data.config.baseBet,
      betLevel: this.data.config.betLevel,
      betSize: this.data.config.betSize,
    };
  },
};
</script>

<style>
.nav-romaplus {
  background-color: #A11010;
  border-radius: 10px
}

.icon-info-romaplus {
  width: 20%;
  height: 100%;
}

.iconSmall-info-romaplus {
  width: 20%;
  height: 120%;
}

.bg-romaplus {
  background: #391818;
}

</style>